/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */

import $ from 'jquery';
import 'jquery-jsonview';
import 'jquery-jsonview/dist/jquery.jsonview.css';
import './taskpane.css';
import { createNestablePublicClientApplication } from "@azure/msal-browser";
import { addHttpTrace, copyToClipboard } from '../utils/addHttpTrace.js';
import { buildTextBody, buildBody } from '../utils/askForHelpButton.js';
import { authPass, getAuthHeader } from '../utils/authHeaderChecks.js';
import { checkCardPayload } from '../utils/checkCardPayload.js';

let publicClientApp = undefined;
const domain = "https://graph.microsoft.com";
Office.onReady(async (info) => {
  if (info.host === Office.HostType.Outlook) {
    console.log("In Office.onReady");
    try {
      publicClientApp = await createNestablePublicClientApplication({
        auth: {
          clientId: "c39229c7-cdc4-45d6-8a75-ce69b0a0dbe4",
          authority: "https://login.microsoftonline.com/common"
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: true
        }
      });
      console.log("MSAL initialized successfully");
      
      $('#errorMessage').text('Loading...');
      $('#errorMessage').show();
      $('#main').hide();
      // Automatically run when taskpane is launched
      await run();
    } catch (error) {
      console.error("Failed to initialize MSAL:", error);
      $('#errorMessage').text('Failed to initialize authentication. Please refresh the add-in.');
      $('#errorMessage').show();
      $('#main').hide();
    }
  }
});

document.getElementById("getProfileButton").onclick = async function () {
    console.log ("In getProfileButton click handler")
    await run();
};

export async function run() {
  const tokenRequest = {
    scopes: ["https://graph.microsoft.com/Mail.Read"],
  };
  let accessToken = null;

  $('#errorMessage').text('Loading...');
  $('#errorMessage').show();
  $('#main').hide();
  $('#blocksContainer').find('.messageBlock').hide();

  // 1. Token fetching
  try {
    console.log("Trying to acquire token silently...");
    const userAccount = await publicClientApp.acquireTokenSilent(tokenRequest);
    console.log("Acquired token silently.");
    accessToken = userAccount.accessToken;
  } catch (error) {
    console.log("Silent token acquisition failed:", error);
    if (error instanceof Error) {
      console.log("Error name:", error.name);
      console.log("Error message:", error.message);    }
  }  
  
  // TODO 2: Call acquireTokenPopup.
  if (accessToken === null) {
    // Acquire token silent failure. Send an interactive request via popup.
    try {
      console.log("Trying to acquire token interactively...");
      const userAccount = await publicClientApp.acquireTokenPopup(tokenRequest);
      console.log("Acquired token interactively.");
      accessToken = userAccount.accessToken;
    } catch (popupError) {
      // Acquire token interactive failure.
      console.log("Interactive token acquisition failed:", popupError);
      if (popupError instanceof Error) {
        console.log("Error name:", popupError.name);
        console.log("Error message:", popupError.message);
      }
    }
  }
  
  // TODO 3: Log error if token still null.
  // Log error if both silent and popup requests failed.
  if (accessToken === null) {
    $('#errorMessage').text('Unable to get accessToken for Graph request.');
    $('#errorMessage').show();
    $('#main').hide();
    return;
  }
  
  // 2. Graph call and 3. Graph call response
  try {
    const response = await getGraphData(accessToken);
    let retryGetToken = 0;
    if (!response) {
        console.error(`Unable to acquire graph data.` + response);
      $('#errorMessage').text('No response from Microsoft Graph. Please try again.');
      $('#errorMessage').show();
      $('#main').hide();
      return;
    }
    if (response.error) {
      // AAD error or other API error
      if (response.error.code && response.error.code.startsWith('AADSTS') && retryGetToken < 1) {
        retryGetToken++;
        await run();
        $('#errorMessage').text('An error occurred: ' + (response.error.message || 'AAD error'));
        $('#errorMessage').show();
        $('#main').hide();
        return;
      } else {
        $('#errorMessage').text('An error occurred: ' + (response.error.message || 'Unknown error'));
        $('#errorMessage').show();
        $('#main').hide();
      }
      return;
    }
    // Success
    console.log(`Acquired graph data.` + response);
    populateData(response);
    $('#main').hide();
  } catch (exception) {
    $('#errorMessage').text('Unable to fetch mail data. Please check your connection or try again.');
    $('#errorMessage').show();
    $('#main').hide();
    // Optionally, trigger fallback dialog
    dialogFallback();
  }

  $('#showAdditional').on('click', function () {
        $('#dignosticsArea').toggle();
    });

    $('.toggleTitleBar').on('click', function () {
        $(this).parent().children('.messageDetailClosed, .messageDetailOpen').toggle();
        $(this).children('.chevron').toggleClass("titleClosed titleOpen");
    });
    var hostName = Office.context.mailbox.diagnostics.hostName;
    var hostVersion = Office.context.mailbox.diagnostics.hostVersion;
    var isMacOutlook = Office.context.mailbox.diagnostics.os;

    if (hostName === "OutlookIOS" || hostName === "OutlookAndroid" || isMacOutlook) {
        $("#clientNotSupportedMessage").show();
    }

    if (hostName === "OutlookIOS" || hostName === "OutlookAndroid") {
        $(".actioncopy").hide();
    }

    if (hostName === "Outlook") {
        const versionSplits = hostVersion.split('.');
        const mainVersion = parseInt(versionSplits[0]);
        const build = parseInt(versionSplits[2]);

        if (mainVersion < 16) {
            document.getElementById("outlook2013Message").style.display = "block";
        } else if (build < MESSAGE_CARD_MIN_OUTLOOK_VERSION) {
            document.getElementById("outlookVersionMessage").style.display = "block";
        } else if (build < ADAPTIVE_CARD_MIN_OUTLOOK_VERSION) {
            document.getElementById("adaptiveCardNotSupportedMessage").style.display = "block";
        }
    }
}

export async function getGraphData(accessToken) {
  const ewsItemId = Office.context.mailbox.item.itemId;
  const restItemId = Office.context.mailbox.convertToRestId(ewsItemId, Office.MailboxEnums.RestVersion.v2_0);  
  var restApiUrl = domain + `/v1.0/me/messages/${encodeURIComponent(restItemId)}`;
    restApiUrl +="?$expand=singleValueExtendedProperties($filter = "
        + "(id eq 'String {00062008-0000-0000-c000-000000000046} Name EntityDocument')"
        + " or "
        + "(id eq 'Boolean {00062008-0000-0000-c000-000000000046} Name EntityExtractionSuccess')"
        + " or "
        + "(id eq 'String {00062008-0000-0000-c000-000000000046} Name EntityExtractionServiceDiagnosticContext')"
        + " or "
        + "(id eq 'String {00062008-0000-0000-c000-000000000046} Name ExplicitMessageCard')"
        + " or "
        + "(id eq 'String {00062008-0000-0000-c000-000000000046} Name ActionExecutionHttpTrace')"
        + " or "
        + "(id eq 'String {00062008-0000-0000-c000-000000000046} Name TeeVersion')"
        + " or "
        + "(id eq 'String {e550b918-9859-47b9-8095-97e4e72f1926} Name IOpenTypedFacet.Com.Microsoft.Graph.MessageCard')"
        + " or "
        + "(id eq 'String 0x007D')"
        + "),Extensions($filter=(Id eq 'Com.Microsoft.Graph.MessageCard'))"

    let data = null;
  try {
    const response = await fetch(restApiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Accept": "application/json",
      }
    });
     data = await response.json();

    if (!response || response.error) {
      const errorText = response ? response.error.message : "Unknown error";
      throw new Error(`Graph API call failed: ${errorText}`);
    }
    return data;
  } 
  catch (error) {
    console.error("Graph API call failed:", error.message);
    throw error;
  }
}

function populateData(odata) {
  var messageCard = null;
  var adaptiveCard = null;
  var htmlCard = null;
  var diagnostics = null;

  if (odata.extensions && odata.extensions.length > 0) {
    var cardExt = odata.extensions[0];
    if (cardExt.MessageCardSerialized) {
        try {
            messageCard = JSON.parse(cardExt.MessageCardSerialized);
        } catch (e) {
            console.error("Failed to parse MessageCardSerialized:", e);
        }
    }

    if (cardExt.AdaptiveCardSerialized) {
        
        try {
            adaptiveCard = JSON.parse(cardExt.AdaptiveCardSerialized);
        } catch (e) {
            console.error("Failed to parse AdaptiveCardSerialized:", e);
        }
    }

    if (cardExt.DeveloperDiagnosticsSerialized) {
        try {
            diagnostics = JSON.parse(cardExt.DeveloperDiagnosticsSerialized);
        } catch (e) {
            console.error("Failed to parse DeveloperDiagnosticsSerialized:", e);
        }
    }
  }

  var svp = odata.SingleValueExtendedProperties;
  if (svp && svp.length > 0) {
      for (var prop in svp) {
          var id = svp[prop].PropertyId;
          var value = svp[prop].Value;
          switch (id) {
              case 'String {00062008-0000-0000-c000-000000000046} Name EntityDocument':
                  if (isValidJsonString(value)) {
                      var entityDocument = JSON.parse(value);
                  }
                  break;
              case 'Boolean {00062008-0000-0000-c000-000000000046} Name EntityExtractionSuccess':
                  if (isValidJsonString(value)) {
                      var entityExtractionSuccess = JSON.parse(value);
                  }
                  break;
              case 'String {00062008-0000-0000-c000-000000000046} Name EntityExtractionServiceDiagnosticContext':
                  if (isValidJsonString(value)) {
                      var entityExtractionDiagnostics = JSON.parse(unicodeEscape(value));
                  }
                  break;
              case 'String {00062008-0000-0000-c000-000000000046} Name ExplicitMessageCard':
                  var explicitMessageCard = value;
                  break;
              case 'String {00062008-0000-0000-c000-000000000046} Name ActionExecutionHttpTrace':
                  if (isValidJsonString(value)) {
                      var actionExecutionHttpTrace = JSON.parse(unicodeEscape(value));
                  }
                  break;
              case 'String {e550b918-9859-47b9-8095-97e4e72f1926} Name IOpenTypedFacet.Com.Microsoft.Graph.MessageCard':
                  {
                        if (isValidJsonString(value)) {
                            let extendedProperty = JSON.parse(unicodeEscape(value));
                            if (extendedProperty.MessageCardSerialized && isValidJsonString(extendedProperty.MessageCardSerialized)) {
                                messageCard = messageCard ?? JSON.parse(unicodeEscape(extendedProperty.MessageCardSerialized));
                            }
                            if (extendedProperty.AdaptiveCardSerialized && isValidJsonString(extendedProperty.AdaptiveCardSerialized)) {
                                adaptiveCard = adaptiveCard ?? JSON.parse(unicodeEscape(extendedProperty.AdaptiveCardSerialized));
                            }
                            if (extendedProperty.DeveloperDiagnosticsSerialized && isValidJsonString(extendedProperty.DeveloperDiagnosticsSerialized)) {
                                diagnostics = diagnostics ?? JSON.parse(unicodeEscape(extendedProperty.DeveloperDiagnosticsSerialized));
                            }
                        }
                        break;
                    }
              case 'String 0x7d':
                  var headers = value;
                  break;
          }
      }
  }

  let bodyHtml = null;

  if (odata.body.contentType === "html") {

      bodyHtml = odata.body.content;
  }

  emailItemPopulated(bodyHtml, messageCard, adaptiveCard, diagnostics, explicitMessageCard, actionExecutionHttpTrace, entityExtractionSuccess, entityDocument, entityExtractionDiagnostics, headers, null);
}

function emailItemPopulated(htmlBody, messageCard, adaptiveCard, diagnostics, explicitMessageCard, actionExecutionHttpTrace, entityExtractionSuccess, entityDocument, entityExtractionDiagnostics, headers, err) {
    if (err === "0") {
        document.getElementById('errorMessage').style.display = 'none';
        document.getElementById('restError').style.display = 'block';
        return;
    }

    if (err) {
        document.getElementById('errorMessage').textContent = err;
        return;
    }

    if (messageCard === null && adaptiveCard === null) {
        if (!err) {
            document.getElementById('cardNotFound').style.display = 'block';

            // Show HTML body if no card found
            var block = document.getElementById('htmlBodyBlock');

            const actionCopyButton = block.querySelector('.actioncopy');
            if (actionCopyButton) {
                actionCopyButton.addEventListener('click', function (event) {
                    event.stopPropagation();
                    copyToClipboard(htmlBody);
                });
            }

            const preElement = block.querySelector('pre');
            if (preElement) {
                preElement.textContent = htmlBody;
            }

            block.style.display = 'block';
        }
        console.log("messageCard === null && adaptiveCard === null");
    }

    document.getElementById('errorMessage').style.display = 'none';
    document.getElementById('main').style.display = 'block';

    addCard('messageCard', messageCard);
    addCard('adaptiveCard', adaptiveCard);
    addHttpTrace(actionExecutionHttpTrace);

    var combinedDiagnostics = enrichDiagnostics(htmlBody, diagnostics, explicitMessageCard, entityExtractionSuccess, entityDocument, headers);
    addCard('diagnostics', combinedDiagnostics);
};

function addCard(name, card) {
  if (card) {
      var cardFormatted = JSON.stringify(card, null, 4);

      var block = document.getElementById(name + "Block");

      // Set up copy button
      var copyButton = block.querySelector('.actioncopy');
      var newCopyButton = copyButton.cloneNode(true); // Remove old listeners
      copyButton.parentNode.replaceChild(newCopyButton, copyButton);

      newCopyButton.addEventListener('click', function (event) {
          event.stopPropagation();
          copyToClipboard(cardFormatted);
      });

      // Set preformatted text
      var pre = block.querySelector('pre');
      pre.textContent = cardFormatted;

      // Show the block
      block.style.display = 'block';
  }
}

function enrichDiagnostics(htmlBody, stampingDiagnostics, explicitMessageCard, entityExtractionSuccess, entityDocument, headers){
    var combinedDiagnostics = {};

    if (stampingDiagnostics) {
        combinedDiagnostics["ActionableMessageStamping"] = stampingDiagnostics;
    }

    combinedDiagnostics['CardEnabledForMessage'] = explicitMessageCard === 'True';

    combinedDiagnostics["ClientName"] = Office.context.mailbox.diagnostics.hostName;

    combinedDiagnostics["ClientVersion"] = Office.context.mailbox.diagnostics.hostVersion;

    var internetMessageId = Office.context.mailbox.item.internetMessageId;
    combinedDiagnostics["InternetMessageId"] = internetMessageId;

    combinedDiagnostics["EntityExtractionSuccess"] = entityExtractionSuccess === true;

    if (combinedDiagnostics.ActionableMessageStamping && combinedDiagnostics.ActionableMessageStamping.Errors && combinedDiagnostics.ActionableMessageStamping.Errors.length > 0) {
        $("#stampingError .messageDetailOpen").empty();
        $.each(combinedDiagnostics.ActionableMessageStamping.Errors, function (idx, err) {
            $("#stampingError .messageDetailOpen").append($('<p>').text(err));
        });
        $("#stampingError").show();
    }

    var messageCardParsed = false;
    var adaptiveCardParsed = false;

    if (entityDocument) {
        var originatorShouldExist = false;
        var originator = null;
        for (var i = 0; i < entityDocument.length; i++) {
            var entity = entityDocument[i];

            switch (entity.type) {
                case "MessageCard":
                    combinedDiagnostics["MessageCardPayloadParsed"] = true;
                    messageCardParsed = true;
                    originatorShouldExist = true;
                    originator = entity.entities[0].originator;
                    break;
                case "AdaptiveCard":
                    combinedDiagnostics["AdaptiveCardPayloadParsed"] = true;
                    adaptiveCardParsed = true;
                    originatorShouldExist = true;
                    originator = entity.entities[0].originator;
                    break;
                case "SignedMessageCard":
                    combinedDiagnostics["SignedMessageCard"] = true;
                    messageCardParsed = true;
                    originatorShouldExist = false;
                    break;
                case "SignedAdaptiveCard":
                    combinedDiagnostics["SignedAdaptiveCard"] = true;
                    adaptiveCardParsed = true;
                    originatorShouldExist = false;
                    break;
                default:
                    break;
            }
        }

        if (originator && originator.length > 0) {
            combinedDiagnostics['Originator'] = originator;
        } else if (originatorShouldExist) {
            combinedDiagnostics['Warning'] = 'Originator not set.';
            $("#originatorNotSetMessage").show();
        }
    } else {
        combinedDiagnostics['Error'] = 'EntityDocument does not exist.';
    }

    if (!entityExtractionSuccess) {
        $("#entityExtractionNotRun").show();
    }

    if (!adaptiveCardParsed && htmlBody) {
        var result = checkCardPayload(htmlBody, "adaptivecard");
        combinedDiagnostics['AdaptiveCardPayload'] = result;
        if (entityDocument && result.found) {
            $("#adaptiveCardPayloadError").show();
        }
    }

    if (!messageCardParsed && htmlBody) {
        result = checkCardPayload(htmlBody, "messagecard");
        combinedDiagnostics['MessageCardPayload'] = result;

        // Note: SignedAdaptiveCard maybe in the message card tag, do not show the error message in this case
        if (entityDocument && result.found && result.type.toLowerCase().indexOf("messagecard") !== -1) {
            $("#messageCardPayloadError").show();
        }
    }

    if (headers) {
        var authHeader = getAuthHeader(headers);
        combinedDiagnostics['AuthHeader'] = authHeader;

        if (!authPass(authHeader)) {
            $("#spfDkimFailMessage").show();
        }
    }
    // $('#diagnosticsBlock').find('pre').JSONView(combinedDiagnostics);
    // $('#diagnosticsBlock').show();
    const diagnosticsBlock = document.getElementById('diagnosticsBlock');
    const pre = diagnosticsBlock.querySelector('pre');

    // Convert the JSON to a formatted string
    pre.textContent = JSON.stringify(combinedDiagnostics, null, 2);

    // Show the block
    diagnosticsBlock.style.display = 'block';

    return combinedDiagnostics;
}

// Utility: Validate and sanitize JSON strings before parsing
function isValidJsonString(str, maxLength = 10000) {
    if (typeof str !== 'string' || str.length > maxLength) return false;
    // Only allow printable ASCII and common JSON characters
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
}

// Utility: Unicode escape all non-alphanumeric characters in a string
function unicodeEscape(str) {
    return str.replace(/[^a-zA-Z0-9{}[\]":,]/g, function(ch) {
        return '\\u' + ('0000' + ch.charCodeAt(0).toString(16)).slice(-4);
    });
}